module.exports = __webpack_public_path__ + "static/img/3_1_4_2.dc586438.jpg";